import { listStyles } from "@insite/content-library/Widgets/Brand/BrandGallery";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import merge from "lodash/merge";
import { css } from "styled-components";

Object.assign(listStyles, {
    container: {
        css: css`
            // padding: 20px;
            margin-bottom: 20px;
        `,
    },
    imageItem: {
        css: css`
            padding: 5px;
            justify-content: center;
            margin-bottom: 20px;
            ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 15px;
                        margin-bottom: 0;
                    `,
                    css`
                        padding: 15px 5px;
                        margin-bottom: 0;
                    `,
                    css`
                        padding: 15px 5px;
                    `,
                    css`
                        padding: 5px;
                    `,
                    css`
                        padding: 5px;
                    `,
                ])};
        `,
    },
    image: {
        css: css`
            max-width: 180px;
        `,
    },
});
